/*
 * Module for managing the site's shell (layout)
 */

rs.module("layouts/site-shell", 
    
    ["ui/framework/userstate-manager", "ui/framework/theme-manager"],

    function (userStateManager, themeManager) {

        var _shellRoot;
        var _shellContent;
        var _shellBottom;

        // Footer display types
        var _footerDisplayTypes = {
            'standard': '',
            'fixed': '_fixed-footer',
            'none': '_no-footer'
        };

        var _contentAreaResizedEventName = "site-shell:contentAreaResized";
        var _footerDisplayChangedEventName = "site-shell:footerDisplayChanged";
        var _footerDisplayStateKey;

        //
        // Initializes the shell
        //
        function initialize(jsSelectors, userStateKeys) {

            _shellRoot = $.js(jsSelectors.root);
            _shellContent = $.js(jsSelectors.content);
            _shellBottom = $.js(jsSelectors.bottom);

            _footerDisplayStateKey = userStateKeys.footerDisplay;

            // Resize observer to monitor the size of the content area
            new ResizeObserver(function () {
                _shellContent.trigger(_contentAreaResizedEventName);
            }).observe(_shellContent[0]);

            // Update our select pickers with window padding based on header and footer heights as these may have changed with the new theme
            themeManager.onThemeChanged(function (params) {

                var dimensions = getHeaderFooterDimensions();
                $('select.selectpicker').each(function (i, obj) {

                    $(this).attr('data-window-padding', `[${dimensions.header.outerHeight}, 0, ${dimensions.footer.outerHeight}, 0]`);
                    $(this).selectpicker('refresh');
                });
            });
        }

        //
        // Gets the list of available footer display types
        //
        function getFooterDisplayTypes() {
            return Object.getOwnPropertyNames(_footerDisplayTypes);
        }

        //
        // Sets how the footer is displayed
        //
        // displayType: Can be 'standard', 'fixed', 'none'
        //
        function setFooterDisplay(displayType) {

            var removeClass = _footerDisplayTypes[getFooterDisplay()];
            var addClass = _footerDisplayTypes[displayType];

            if (typeof addClass === "undefined") {
                throw new Error("Footer display type '" + displayType + "' is not valid.");
            }

            _shellRoot.removeClass(removeClass);
            _shellRoot.addClass(addClass);

            _shellRoot.trigger(_footerDisplayChangedEventName);

            // Persist the state
            userStateManager.persist(_footerDisplayStateKey, addClass);
        }

        //
        // Sets the current footer display type
        //
        function getFooterDisplay() {
            for (var displayType in _footerDisplayTypes) {
                var cssClass = _footerDisplayTypes[displayType];

                if (cssClass !== "" && _shellRoot.hasClass(cssClass)) {
                    return displayType;
                }
            }

            return "standard";
        }

        //
        // Returns the jQuery wrapped DOM element of the site-shell
        //
        function getShellRoot() {
            return _shellRoot;
        }

        //
        // Returns the jQuery wrapped DOM element of the site-shell bottom element
        //
        function getShellBottom() {
            return _shellBottom;
        }

        //
        // Returns the dimensions of the header and footer
        //
        function getHeaderFooterDimensions() {

            var header = $('.site-shell__top').length > 0 ? $('.site-shell__top') : $('.external-shell__top');
            var footer = $('.site-shell__bottom').length > 0 ? $('.site-shell__bottom') : $('.external-shell__bottom');

            if (header.length == 0 || footer.length == 0) {
                {
                    throw new Error('Elements with class .site-shell__top and/or .site-shell__bottom could not be found.');
                }
            }

            return {
                header: {
                    outerHeight: header.outerHeight(),
                    outerWidth: header.outerWidth()
                },

                footer: {
                    outerHeight: footer.outerHeight(),
                    outerWidth: footer.outerWidth()
                }
            };
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            footerDisplayChanged: function (handler) { _shellRoot.on(_footerDisplayChangedEventName, handler); },
            contentAreaResized: function (handler) { _shellContent.on(_contentAreaResizedEventName, handler); },
            getHeaderFooterDimensions
        };

        // Add footer display types getter\setter
        Object.defineProperty(exports, 'footerDisplay',
            {
                get: getFooterDisplay,
                set: setFooterDisplay
            });

        // Add footer display type list getter\setter
        Object.defineProperty(exports, 'footerDisplayTypes',
            {
                get: getFooterDisplayTypes
            });

        // Add shell getter
        Object.defineProperty(exports, 'root',
            {
                get: getShellRoot
            });

        Object.defineProperty(exports, "bottom",
            {
                get: getShellBottom
            });

        return exports;
    }
);